import { ContentItem } from '@kentico/kontent-delivery';
import get from 'lodash/get';
import { Models } from '.';
import { IPromoSectionProps } from '../components/promo-section/promo-section';
import { IOurTeamProps } from '../components/our-team/our-team';
import { IOurTeamPhotosLinkProps } from '../components/our-team-photos-link/our-team-photos-link';
export class OurTeamModel extends ContentItem {
  get promoSection(): IPromoSectionProps {
    const getPromoSection = get(
      this._config,
      'elements.our_team_promo_section.value[0]',
      ''
    );
    const formPromoSection = Models.PromoSectionModel.create(
      getPromoSection as IPromoSection
    );
    return formPromoSection;
  }
  get featuredEmployees(): string {
    const getPersons = get(
      this._config,
      'elements.our_team_featured_employees.value',
      null
    );

    const transformPersons = getPersons
      ? getPersons.map((person: IKontentItem) =>
          Models.EmployeeBoxModel.create(person as IEmployeeBox)
        )
      : null;
    return transformPersons;
  }

  get ourTeamPhotosLink(): IOurTeamPhotosLinkProps | null {
    const getPhotosLink = get(
      this._config,
      'elements.photos_link.value[0]',
      null
    );

    const transofrmPhotosLink = getPhotosLink
      ? Models.OurTeamPhotosLinkModel.create(
          getPhotosLink as IOurTeamPhotosLink
        )
      : null;

    return transofrmPhotosLink;
  }

  public static create(data: IOurTeam): IOurTeamProps {
    const {
      promoSection,
      featuredEmployees,
      ourTeamPhotosLink
    } = new OurTeamModel(data);
    return {
      promoSection,
      featuredEmployees,
      ourTeamPhotosLink
    };
  }
}
